import { HotelRateDisplayPreferences } from '../constants';
// oxlint-disable-next-line import/extensions
import { HotelRate } from '../types/hotel';

const getHotelRateToDisplay = (priceDisplayPreference: number, rate: HotelRate): number => {
  if (priceDisplayPreference === HotelRateDisplayPreferences.NightlyPrice) {
    return rate.averageNightlyRate;
  }
  if (priceDisplayPreference === HotelRateDisplayPreferences.NightlyTotalWithoutTax) {
    return rate.averageNightlyRateBeforeTax;
  }
  if (priceDisplayPreference === HotelRateDisplayPreferences.TotalRate) {
    return rate.price;
  }
  return 0;
};

export default getHotelRateToDisplay;
